const config = {
  genesysCloud: {
    region: 'mypurecloud.de',
    clientId: import.meta.env.VITE_GENESYS_CLIENT_ID,
  },
  aiService: {
    serviceUrl: import.meta.env.VITE_AI_SERVICE_URL,
    apiKey: import.meta.env.VITE_AI_API_KEY,
  },
  webSocket: {
    maxReconnectAttempts: 3,
    reconnectDelay: 2000,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
  },
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
};

// Validation
if (!config.genesysCloud.clientId) {
  console.warn('Please configure your Genesys Cloud Client ID');
}

export default config;
